import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    // Admin has access to everything (treated as catechist-or-better)
    if (user.role === "admin") return children;
    // Redirect to the user's own dashboard
    const target = user.role === "catechist" ? "/dashboard/catequista" : "/dashboard/estudiante";
    return <Navigate to={target} replace />;
  }
  return children;
}
